import { Component, computed, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { ApmTranslatePipe } from '@mitsubishi/core';
import { ApmFaIconComponent, IconComponent, SectionTitleComponent } from '@mitsubishi/shared/ui';
import { DialogService } from '@mitsubishi/ui/dialog';
import { InlineSpinnerComponent } from '@mitsubishi/ui/spinner';

import { ALL_OPTIONAL_SECTIONS, OptionalSection } from '../../models/chiller-free-st.model';
import { ChillerFreeStDataSheetStore } from '../../stores/chiller-free-st-data-sheet.store';
import {
  ChillerFreeStDatasheetSettingsDialogComponent,
  ChillerFreeStDatasheetSettingsDialogData,
} from '../chiller-free-st-datasheet-settings-dialog/chiller-free-st-datasheet-settings-dialog.component';

@Component({
  selector: 'apm-chiller-free-st-data-sheet-preview',
  imports: [ApmTranslatePipe, SectionTitleComponent, InlineSpinnerComponent, IconComponent, ApmFaIconComponent],
  templateUrl: './chiller-free-st-data-sheet-preview.component.html',
  styleUrl: './chiller-free-st-data-sheet-preview.component.scss',
})
export class ChillerFreeStDataSheetPreviewComponent {
  readonly store = inject(ChillerFreeStDataSheetStore);
  readonly #sanitizer = inject(DomSanitizer);
  readonly #dialogService = inject(DialogService);

  readonly sanitizedPdfUrl = computed(() => {
    const url = this.store.pdfUrl();
    return url ? this.#sanitizer.bypassSecurityTrustResourceUrl(url) : null;
  });

  openDatasheetSettings() {
    const datasheetPdfRequest = this.store.getDatasheetPdfRequest();
    if (!datasheetPdfRequest) return;

    const currentSections = this.store.optionalSections() ?? ALL_OPTIONAL_SECTIONS;

    this.#dialogService
      .openDialog<ChillerFreeStDatasheetSettingsDialogComponent, OptionalSection[]>(
        ChillerFreeStDatasheetSettingsDialogComponent,
        'md',
        {
          selectedSections: currentSections,
          datasheetPdfRequest,
        } satisfies ChillerFreeStDatasheetSettingsDialogData
      )
      .afterClosed()
      .subscribe(result => {
        if (result) {
          this.store.setOptionalSections(result);
          this.store.regeneratePdf();
        }
      });
  }
}
